import React, { useState } from "react";
import "./GuideMoney.css";
// img
import buy from "./image/buy.png";
import cart from "./image/cart.png";
import map from "./image/map.png";
import persent from "./image/persent.png";
import Video from "Assets/Video/work.mp4";

import { Play, X } from "react-bootstrap-icons";
import { Modal } from "react-bootstrap";

const GuideMoney = () => {
  const [modalShow, setModalShow] = useState(false);

  const handleShow = () => setModalShow(true);
  return (
    <div className="all-guide-money container my-5 ">
      <div className="row text-center py-4">
        <h4>راهنمای کسب درآمد با داپ‌اَپ</h4>
        <p className="vazir-l">
          با داپ‌اَپ می تونی از خریدهای روزانه ات درآمد داشته باشی
        </p>
      </div>
      <div className=" box-4-guide ">
        <div className="each-div-guide bg-danger-guide radius-boxes2">
          <img src={cart} loading="lazy" className="" alt="" />
          <h5 className="text-white">کارت بانکی تو ثبت کن</h5>
          <p className="text-white vazir-l m-0 ">
            {" "}
            وارد کردن شماره 16 رقمی کارت کافیه
          </p>
        </div>
        <div className="each-div-guide bg-green-guide radius-boxes1">
          <img src={map} className="" loading="lazy" alt="" />
          <h5 className="text-white">فروشگاه مورد نظرتو روی نقشه پیدا کن</h5>
          <p className="text-white vazir-l m-0">
            فروشگاه و کسب وکارهای زیادی داپ‌اَپی هستن
          </p>
        </div>
        <div className="each-div-guide bg-wrning-guide radius-boxes1 ">
          <img src={buy} className="" loading="lazy" alt="" />
          <h5 className="text-white">با همون کارت بانکیت خرید کن</h5>
          <p className="text-white vazir-l m-0">
            هم حضوری می تونی خرید کنی هم آنلاین
          </p>
        </div>
        <div className="each-div-guide bg-info-guide radius-boxes2">
          <img src={persent} className="" loading="lazy" alt="" />
          <h5 className="text-white">از 4 تا 54 درصد پاداش نقدی بگیر</h5>
          <p className="text-white vazir-l m-0">
            پاداش نقدی هر روز ساعت 9 صبح توی کیف پولته
          </p>
        </div>
      </div>
      <div className="training-video ">
        <button
          className="bg-info border-0 text-white all-butten-site px-3 py-1 "
          onClick={handleShow}
        >
          <Play size={25} color="white" />
          ویدیوی آموزش کار با داپ‌اَپ
        </button>
        <MyVerticallyCenteredModal
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      </div>
    </div>
  );
};

export default GuideMoney;

// MODALL
const MyVerticallyCenteredModal = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header className="">
        <Modal.Title
          id="contained-modal-title-vcenter"
          className=" d-flex justify-content-between align-items-center
         w-100"
        >
          ویدیو اموزشی کار با داپ اَپ
          <X
            size={30}
            onClick={props.onHide}
            className=" carousel-control-next-icon"
          />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <video width="100%" height="350px" controls>
          <source src={Video} type="video/mp4" />
        </video>
      </Modal.Body>
    </Modal>
  );
};
